/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  Dispatch,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react'
import {
  ArrayLayoutProps,
  composePaths,
  createDefaultValue,
  isObjectArrayWithNesting,
  RankedTester,
  rankWith,
  toDataPath
} from '@jsonforms/core'
import get from 'lodash/get'

import { useDispatch } from 'react-redux'
import './styles.scss'

import {
  ctxDispatchToControlProps,
  useJsonForms,
  withJsonFormsArrayLayoutProps
} from '@jsonforms/react'
import CardRenderer from '../CardRenderer'

import { Card } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import Icon from '@mdi/react'
import { mdiPlusThick } from '@mdi/js'
import { useAppSelector } from 'hooks/store'
import { findAllByKey, getRandomString } from '../../utils'
import { JsonFormCustomContext } from '../../QuestionnareForm'
import { MatterClientPortalQuestionnaireSectionStatus } from 'share/domain/case'

export const ArrayLayoutRenderer = ({
  visible,
  uischema,
  schema,
  label,
  renderers,
  cells,
  data,
  path,
  addItem,
  removeItems
}: ArrayLayoutProps) => {
  const dispatch = useDispatch()
  const [titleData, setTitleData] = useState<any[]>([])
  /**
   * To keep track of array length.
   * This state will be used to check if the array item is added or deleted.
   * Based the value of this state, activeId will be set.
   *
   */
  const [useData, setUseData] = useState<number>(data)

  /**
   * Card item to be shown as expanded.
   * Start with 0 th card.
   * activeId = newly Added card, in case new Card is added.
   * activeId = 0 , in case a Card is deleted.
   */
  const [activeId, setActiveId] = useState('0')

  /**
   * Maintain a list of each card error. Used to show the error icon on a card.
   * If the validation mode == 'ValidateAndShow' and card has errors, add a entry in list.
   */
  const [errorList, setErrorList] = useState<string[]>([])

  const currentActiveQuestionId = useAppSelector(
    (state) => state.activeSection.section?.currentActiveQuestionId
  )
  const activeSection = useAppSelector((state) => state.activeSection)
  const activeSectionStatus = activeSection.section?.sectionStatus

  const currentActiveQuestionIdRef = useRef(-1)

  const customJsonFormContextInstance = useContext(JsonFormCustomContext)

  const addButtonRef = useRef(null)
  const elements = uischema.options?.['detail']['elements']
  const titleKey = toDataPath(elements[0]['scope'])
  const jsonFormsContext = useJsonForms()
  const ctx = useJsonForms()
  // eslint-disable-next-line
  const dispatchProps = ctxDispatchToControlProps(ctx.dispatch as Dispatch<any>)
  const loading = false
  const { core } = jsonFormsContext
  const childLabel = (uischema as any).childLabel

  const getTitle = useMemo(() => {
    const getTitleFunction = () => {
      const newTitleData: string[] = []
      if (core?.data && core?.data[path]) {
        let targetObject = null
        for (let i = 0; i < core?.data[path].length; i++) {
          const index = ' ' + (i + 1)
          targetObject = core?.data[path][i]
          let title = get(
            targetObject,
            titleKey,
            (uischema as any).header + index
          )
          title =
            typeof title === 'object' ? (uischema as any).header + index : title
          if (title.trim().length > 29) {
            title = title.trim().substring(0, 27) + '...'
          }
          newTitleData.push(title)
        }
        setTitleData(newTitleData)
      }
    }
    return getTitleFunction
  }, [core?.data, uischema])

  useEffect(() => {
    // Component mounted
    setUseData(data)
    setActiveId(customJsonFormContextInstance.cardActiveIndex)

    return () => {
      // Component unmounted
    }
  }, [])

  useEffect(() => {
    if (currentActiveQuestionId !== currentActiveQuestionIdRef.current) {
      setUseData(data)
      currentActiveQuestionIdRef.current = currentActiveQuestionId as number
    }
  }, [currentActiveQuestionId])

  useEffect(() => {
    if (visible) {
      getTitle()
    }
  }, [visible, getTitle])

  useEffect(() => {
    if (
      useData != data &&
      currentActiveQuestionId === currentActiveQuestionIdRef.current
    ) {
      if (visible) {
        //Add case
        if (useData < data) {
          toggleActive(data - 1)
        }
        //Delete case
        if (useData > data) {
          toggleActive(0)
        }
        setUseData(data)
      } else {
        setUseData(data)
        toggleActive(-1)
        if (core?.validationMode) {
          core.validationMode = 'ValidateAndHide'
        }
      }
    }
  }, [visible, data])

  function getNavigationErrorsForArrayItem(index: number) {
    const arrayItem = core?.data && core?.data[path] && core?.data[path][index]
    const navigationItems = findAllByKey(arrayItem, 'navigation')
    if (navigationItems?.length) {
      const foundNavigationError = navigationItems.find(
        (navigationObject: { isCompleted: boolean }) =>
          navigationObject.isCompleted === false
      )
      return foundNavigationError ? true : false
    }
    return false
  }

  useEffect(() => {
    if (core?.validationMode != 'ValidateAndShow') {
      setErrorList([])
    } else {
      let found
      const foundErrorList: string[] = []
      for (let i = 0; i < data; i++) {
        if (core?.errors) {
          found = core?.errors.find((error) => {
            return (
              ((error.keyword === 'required' ||
                error.message === 'should NOT be valid') &&
                error.dataPath.includes(path + '.' + i)) ||
              getNavigationErrorsForArrayItem(i)
            )
          })
          if (found) {
            foundErrorList.push(i + '')
          }
        }
      }
      setErrorList(foundErrorList)
    }
  }, [core?.errors, core?.validationMode])

  const addItemCb = useCallback(
    (p: string, value: any) => {
      value = {
        ...value,
        parentId: core?.data.id,
        id: getRandomString()
      }
      return addItem(p, value)
    },
    [addItem]
  )

  const removeItemsCb = useCallback(
    (path: string, toDelete: number[]) => {
      if (removeItems && visible) {
        //setActiveId('0')
        return removeItems(path, toDelete)
      }
    },
    [removeItems, visible]
  )

  const toggleActive = (id?: number) => {
    if (activeId === '' + id) {
      setActiveId('')
    } else {
      setActiveId((id as number).toString())
    }
  }

  const mouseClickEvents = ['mousedown', 'click', 'mouseup']
  const simulateMouseClick = (element: Element | null) => {
    mouseClickEvents.forEach((mouseEventType) => {
      if (element) {
        element.dispatchEvent(
          new MouseEvent(mouseEventType, {
            view: window,
            bubbles: true,
            cancelable: true,
            buttons: 1
          })
        )
      }
    })
  }
  useEffect(() => {
    let timeOut: any
    if (visible) {
      if (addButtonRef && data === 0) {
        setActiveId('-1')
        timeOut = setTimeout(() => {
          simulateMouseClick(addButtonRef.current)
        }, 500)
      }
    }

    if (!visible && data) {
      timeOut = setTimeout(() => {
        dispatchProps.handleChange(path, [])
      }, 500)
    }

    return () => {
      if (timeOut) {
        clearTimeout(timeOut)
      }
    }
  }, [visible, data])

  const getErrorClass = (index: number) => {
    if (core?.validationMode != 'ValidateAndShow') {
      return 'hidden'
    }

    if (errorList?.length) {
      return errorList.indexOf(index + '') != -1 ? '' : 'hidden'
    }
    return 'hidden'
  }

  const toRender = () => {
    return (
      <Accordion activeKey={activeId} className='questionnaire-accordion'>
        {Array(data)
          .fill(0)
          .map((_, i) => {
            return (
              <Card key={i}>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={i + ''}
                  onClick={() => toggleActive(i)}
                >
                  <span className='custom-header'>{titleData[i]}</span>
                  {activeId === '' + i && (
                    <span className='mdi mdi-chevron-down float-right'></span>
                  )}
                  {activeId !== '' + i && (
                    <span className='mdi mdi-chevron-up float-right'></span>
                  )}
                  <span
                    className={`mdi mdi-alert-rhombus-outline float-right ${getErrorClass(
                      i
                    )}`}
                  ></span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={i + ''}>
                  <Card.Body>
                    <CardRenderer
                      key={data}
                      index={i}
                      schema={schema}
                      uischema={uischema}
                      path={composePaths(path, `${i}`)}
                      renderers={renderers}
                      cells={cells}
                      onRemove={removeItemsCb(path, [i])}
                      dataLength={data}
                      isVisible={visible}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )
          })}
      </Accordion>
    )
  }

  return (
    <>
      <div hidden={!visible} className='array-container'>
        {childLabel ? (
          <div className='array-label child' data-testid='array-child-label'>
            {childLabel}
          </div>
        ) : (
          <div className='array-label'>{label}</div>
        )}

        {toRender()}
        {activeSectionStatus !==
          MatterClientPortalQuestionnaireSectionStatus.Submitted &&
        activeSectionStatus !==
          MatterClientPortalQuestionnaireSectionStatus.Imported ? (
          <div className='add-btn-container'>
            <button
              ref={addButtonRef}
              id='add-btn'
              className='add-more-btn btn btn-outline-secondary'
              onClick={addItemCb(path, createDefaultValue(schema))}
              data-testid='array-add-btn'
            >
              <Icon path={mdiPlusThick} size={0.8} className='mdi-plus-icon' />
              <span>{(uischema as any).addLabel}</span>
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}

export const arrayLayoutTester: RankedTester = rankWith(
  5,
  isObjectArrayWithNesting
)
export default withJsonFormsArrayLayoutProps(ArrayLayoutRenderer)
